<div
  class="relative flex h-[520px] w-full flex-col items-center rounded-3xl bg-neutrals-0 p-10 text-center md:w-[620px]"
>
  <button
    type="button"
    class="absolute right-6 top-6 cursor-pointer bg-transparent"
    aria-label="Cerrar"
    (click)="finish()"
  >
    <ui-icon
      name="close"
      size="24"
      mobile-size="24"
      fill="neutrals-900"
    ></ui-icon>
  </button>

  <div class="flex flex-col items-center gap-4">
    <ui-illustrative-icon
      *ngIf="step.illustration"
      [attr.name]="step.illustration"
      size="m"
      mobile-size="m"
    ></ui-illustrative-icon>

    <div
      *ngIf="step.iconName"
      class="flex h-[88px] w-[88px] items-center justify-center rounded-[26px]"
      [ngClass]="step.badgeClass"
    >
      <ui-icon
        [iconName]="step.iconName"
        [fill]="step.iconFill"
        size="40"
        mobile-size="40"
      ></ui-icon>
    </div>

    <div class="flex flex-col gap-1">
      <ui-paragraph
        type="p24"
        mobile-type="p18"
        font-weight="semibold"
        text-color="neutrals-900"
        [content]="step.title"
      />
      <ui-paragraph
        *ngIf="step.subtitle"
        type="p14"
        mobile-type="p12"
        font-weight="semibold"
        text-color="neutrals-600"
        [content]="step.subtitle"
      />
    </div>

    <div class="flex flex-col gap-1">
      <ui-paragraph
        *ngFor="let line of bodyLines"
        type="p16"
        mobile-type="p14"
        font-weight="regular"
        text-color="neutrals-700"
        [content]="line"
      />
    </div>
  </div>

  <div class="flex-1"></div>

  <div class="flex w-full flex-col items-center gap-12">
    <div class="flex gap-2">
      <span
        *ngFor="let dot of steps; index as i"
        class="h-4 w-4 rounded-full"
        [ngClass]="i === currentStep ? 'bg-primary-500' : 'bg-primary-100'"
      ></span>
    </div>

    <ui-button
      type="primary"
      responsive="false"
      size="lg"
      [attr.button-text]="step.buttonLabel"
      [enabled]="true"
      [isLoading]="false"
      (click)="next()"
    ></ui-button>
  </div>
</div>
